import { MtTask, MtUser, MtTaskAttachment, MtDriveFile } from "server/models"
import { OrderType, DeadlineFilters } from "client/utils"
import { TableGroupedIds } from "client/components"
import { UserFilters, LifecyclePhaseList } from "client/store"


export interface TaskProps {
    taskId: number
}
export interface TaskObjectProps {
    task: MtTask
}

export type TaskValidation = { [key in keyof MtTask]?: string}

export type TasksOnSelect = (tasks: readonly MtTask[]) => void

export interface TaskList { [taskId: number]: MtTask }
export interface TaskGroupedIds { [parentTaskId: number]: readonly TableGroupedIds[] } // parentTaskId = 0 for the main list
export interface TaskProjectGroupedIds { [projectId: number]: TableGroupedIds }
export interface TaskViewAttachments { [taskId: number]: readonly MtTaskAttachment[] }
export interface TaskLifecyclePhaseIds { [projectId: number]: readonly number[] }

export interface TaskSort {
    [parentTaskId: number]: { // parentTaskId = 0 for the main list
        sortColumn: keyof MtTask
        sortOrder: OrderType
    }
}

export interface TaskFiltersStatus {
    pending: boolean
    inProgress: boolean
    pendingReview: boolean
    completed: boolean
    deferred: boolean
}
export interface TaskFilters extends DeadlineFilters {
    name?: string
    projectId?: number
    creator?: number
    responsible?: number

    highPriority?: boolean
    status: TaskFiltersStatus
    search?: string
}

export interface TaskState {
    baseRoute: string
    showColumnSettings: boolean // same settings for main list and subtasks
    onSelect: TasksOnSelect
    selected: readonly number[]

    // don't use "reloadList" and "reloadView" - this will coas reloading of taskList on all nested modals of List/View pages
    taskList: TaskList
    taskGroupedIds: TaskGroupedIds
    taskSort: TaskSort
    filters: TaskFilters // only for the main list, subtasks have no filters

    taskEdit: MtTask
    attachmentsEdit: readonly MtDriveFile[]
    taskProjectGroupedListEdit: TaskList // to select parent task
    taskProjectGroupedIdsEdit: TaskProjectGroupedIds
    lifecyclePhaseListEdit: LifecyclePhaseList
    lifecyclePhaseIdsEdit: TaskLifecyclePhaseIds
    reloadEdit: boolean

    attachmentsView: { [taskId: number]: readonly MtTaskAttachment[] }

    // popup menu
    active: MtTask
    menuShow: boolean
    menuTarget: any

    delegateUsers: {
        userIds: readonly number[]
        sortColumn: keyof MtUser
        sortOrder: OrderType
        filters: UserFilters
        selected: readonly number[]
    }
}

export const TASK_BASE_ROUTE = "TASK_BASE_ROUTE"
export const TASK_COLUMN_SETTINGS = "TASK_COLUMN_SETTINGS"
export const TASK_ON_SELECT = "TASK_ON_SELECT"
export const TASK_SELECTED = "TASK_SELECTED"

export const TASK_LIST = "TASK_LIST"
export const TASK_GROUPED_IDS = "TASK_GROUPED_IDS"
export const TASK_SORT = "TASK_SORT"
export const TASK_FILTERS = "TASK_FILTERS"

export const TASK_EDIT = "TASK_EDIT"
export const TASK_ATTACHMENTS_EDIT = "TASK_ATTACHMENTS_EDIT"
export const TASK_PROJECT_GROUPED_LIST_EDIT = "TASK_PROJECT_GROUPED_LIST_EDIT"
export const TASK_PROJECT_GROUPED_IDS_EDIT = "TASK_PROJECT_GROUPED_IDS_EDIT"
export const TASK_LIFECYCLE_PHASE_LIST_EDIT = "TASK_LIFECYCLE_PHASE_LIST_EDIT"
export const TASK_LIFECYCLE_PHASE_IDS_EDIT = "TASK_LIFECYCLE_PHASE_IDS_EDIT"
export const TASK_RELOAD_EDIT = "TASK_RELOAD_EDIT"

export const TASK_ATTACHMENTS_VIEW = "TASK_ATTACHMENTS_VIEW"

export const TASK_ACTIVE = "TASK_ACTIVE"
export const TASK_POPUP_MENU_SHOW = "TASK_POPUP_MENU_SHOW"
export const TASK_POPUP_MENU_TARGET = "TASK_POPUP_MENU_TARGET"

export const TASK_DELEGATE_USER_IDS = "TASK_DELEGATE_USER_IDS"
export const TASK_DELEGATE_SORT = "TASK_DELEGATE_SORT"
export const TASK_DELEGATE_FILTERS = "TASK_DELEGATE_FILTERS"
export const TASK_DELEGATE_SELECTED = "TASK_DELEGATE_SELECTED"
